import ProjectService from "src/services/ProjectService";
import ModuleCreator from "src/store/ModuleCreator";

export const types = {
	PRIVATE_TYPE: 1,
	CONSTRUCTION_TYPE: 2,
	CLOSE: "project/close",
	IMPORT: "project/import"
};
export const params = {
	branch_id: null,
	client_id: null,
	building: "",
	entrance: "",
	name: "",
	address: "",
	city: "",
	contractor: "",
	contact: "",
	contact2: "",
	contact3: "",
	contact_tel: "",
	contact2_tel: "",
	contact3_tel: "",

};

/**
@namespace
@property  {object} module,
@property  {object} module.state,
@property  {object} modules.project,
@property  {array}  modules.projects
 **/

const module = {
	state: {},
	mutations: {},
	getters: {},
	actions: {
		async [types.CLOSE]({commit}, project) {
			let response = await ProjectService.close(project.id);
			commit(types.REMOVE, project);
			return response;
		},
		async [types.IMPORT]({commit}, project) {
			let response = await ProjectService.import(project);
			return response;
		}
	},
	types: types
};
export default ModuleCreator("project", ProjectService, module, types, params);
